import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { PPFolderReturnToEnum } from 'app/enums/pp-file-directory.enum';

@Component({
  selector: 'app-file-navigation',
  templateUrl: './file-navigation.component.html',
  styleUrls: ['./file-navigation.component.scss']
})
export class FileNavigationComponent implements OnInit, OnChanges {

  returnToEnum = PPFolderReturnToEnum;

  @Input() directoryString: string;
  @Input() isLoading: boolean = false;
  @Input() maxDisplay: number = 5;
  @Input() disabled: boolean = false;
  directories: string[] = [];

  @Output() returnEmmiter: EventEmitter<PPFolderReturnToEnum>;

  constructor(
    private _router: Router,
    private _nav: FuseNavigationService,
    private _translate: TranslateService
  ) {
    this.returnEmmiter = new EventEmitter();
  }

  ngOnInit(): void {
    this.setDirectories();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.directoryString) {
      this.setDirectories();
    }
  }

  setDirectories(): void {
    if (this.directoryString && this.directoryString.length) {
      this.directories = this.directoryString.split('||');
      this.directories.shift();
      this.directories = this.directories.filter(d => d !== '' && d !== ' ');
    } else {
      this.directories = [];
    }
  }

  getParentName(): string {
    if (this.directories.length > 1) {
      return this.directories[this.directories.length - 2];
    } else {
      return this._translate.instant('PP.ROOT_FOLDER');
    }
  }

  returnTo(directory: PPFolderReturnToEnum): void {
    switch (directory) {
      case PPFolderReturnToEnum.home:
        this.returnEmmiter.emit(PPFolderReturnToEnum.home);
        break;
      case PPFolderReturnToEnum.parent:
        this.returnEmmiter.emit(PPFolderReturnToEnum.parent);
        break;
    }
  }

}
